import React, { useCallback, useContext, useEffect, useState } from 'react';
import Paper from "@mui/material/Paper";
import { Container, Divider } from "@mui/material";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useForm } from 'react-hook-form';
import { useHistory } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from '@mui/material/Alert';
import Link from "@mui/material/Link";
import Background from "../../../assets/Ocean-bg.jpg";
import logo from "../../../assets/v2/Logo-Orca.svg";
import { LoginStyle } from "../../../styles/pages/auth/LoginStyle";
import { AppContext, AuthContext } from "../../../App";
import Copyright from "../utils/Copyright";
import { setCloseSnackbar, setOpenSnackbar } from "../../../services/AppServices";
import { registUser } from "../../../services/AuthServices";
import { PrivacyDialog } from '../utils/PrivacyDialog';


export const RegisterForm = () => {
	const classes = LoginStyle();
	const appContext = useContext(AppContext);
	const authContext = useContext(AuthContext);
	const { handleSubmit, watch } = useForm({ mode: "onChange" });
	const [submit, setSubmit] = useState(false);
	const [read, setRead] = useState(false);
	const [dialogOpen, setDialogOpen] = React.useState(true);

	const history = useHistory();

	const onSubmit = useCallback((data) => {
		if (!read) {
			setOpenSnackbar("warning", "Ops, non hai letto ed accettato l'informativa...", appContext.dispatch);
			setTimeout(() => {
				window.location.reload();
			}, 1000)
		} else if (!data.userPicture || (data.userPicture && data.userPicture.length === 0)) {
			setOpenSnackbar("warning", "Ops, non hai allegato il file richiesto", appContext.dispatch);
		} else {
			setSubmit(true);
			registUser(data, authContext.dispatch);
		}
	}, [authContext.dispatch, appContext.dispatch, read]);

	const handleLogin = useCallback(() => {
		history.push("login")
	}, [history])

	useEffect(() => {
		if (!authContext.state.loadingRegister && authContext.state.errorRegister === "") {
			setSubmit(false);
			setOpenSnackbar("success", "Sei stato registrato correttamente! Ora puoi accedere!", appContext.dispatch);
			history.push("/login");
		} else if (!authContext.state.loadingRegister && authContext.state.errorRegister.length > 1) {
			setSubmit(false);
			setOpenSnackbar("error", authContext.state.errorRegister, appContext.dispatch);
		}
	}, [authContext.state.loadingRegister, authContext.state.errorRegister, appContext.dispatch, history])

	useEffect(() => {
		document.body.style =
			`background-image: url(${Background});
		background-attachment: fixed;
    background-size: cover;`;
	}, []);

	const handleCloseSnack = useCallback(() => {
		setCloseSnackbar(appContext.dispatch);
	}, [appContext.dispatch]);

	return (
		<React.Fragment>
			{dialogOpen && <PrivacyDialog open={dialogOpen} onClose={setDialogOpen} read={read} setRead={setRead}/>}
			<Container maxWidth={"md"} className={classes.container} component={"main"}>
				<Paper variant={"elevation"} className={classes.paperRegist} elevation={18} component={"article"}>
					<form onSubmit={handleSubmit(onSubmit)} className={classes.form}>
						<Grid container spacing={2}>
							<Grid item xs={12} className={classes.flexGrid}>
								<img className={classes.logo} src={logo} alt={"logo"} />
							</Grid>
							<Grid item xs={12}>
								<Typography className={classes.title} variant={"h3"}><b>Ocean</b></Typography>
							</Grid>
							<Grid item xs={12}>
								<Typography className={classes.subTitle} variant={"body1"}>
									Sistema per la gestione ed il monitoraggio dei pazienti dell'ASL Città di Torino
								</Typography>
								<Typography className={classes.subTitle} variant={"body1"}>
									Compila i seguenti campi per registrarti nel sistema.
								</Typography>
							</Grid>
							{/*//TODO metto anagrafica completa*/}

							<Grid item xs={12} sm={12}>
								<Divider variant="fullWidth"
								/>
							</Grid>

							<Grid item xs={12} sm={12}>
								<Typography>Caricare fotografia con inquadrato viso ben illuminato
								e interno della carta d'identità leggibile
								</Typography>
							</Grid>

							<Grid item xs={12} sm={8}>
								<Typography variant={"subtitle1"}>
									File caricato: <i>{watch("userPicture")?.[0] ? watch("userPicture")?.[0]?.name : "Nessun file caricato"}
									</i>
								</Typography>
							</Grid>


							<Grid item xs={12} style={{ width: "80%" }}>
								<Button
									type="submit"
									fullWidth={true}
									variant="contained"
									color="secondary"
									onClick={handleSubmit(onSubmit)}
									className={classes.submit}
									disabled={submit}
								>
									{
										submit ?
											<CircularProgress size={24} /> :
											<React.Fragment><b>Registrati</b></React.Fragment>
									}
								</Button>
							</Grid>

							<Grid item xs={12}>
								<Link
									className={classes.link}
									variant="body2"
									color={"inherit"}
									onClick={handleLogin}
								>
									Hai già un account? Accedi
								</Link>
							</Grid>
						</Grid>
					</form>
					<Box mt={4}>
						<Copyright />
					</Box>
				</Paper>
			</Container>
			<Snackbar open={appContext.state.open} autoHideDuration={3000} onClose={handleCloseSnack}>
				<Alert style={{ borderRadius: 28 }} onClose={handleCloseSnack}
					severity={appContext.state.severity}>
					{appContext.state.message}
				</Alert>
			</Snackbar>
		</React.Fragment>
	);
}

function Alert(props) {
	return <MuiAlert elevation={16} variant="filled" {...props} />;
}
